import Tooltip from "../tooltip/tooltip";
import { useState } from "react";
import { usePostAppointmentsProgramsMutation } from "../../services/api/utils.api";
import { IAppointmentsProgram } from "../../services/types/utils.types";
import { tWithKeyAttr as t } from "../../i18nHelper";


function RestoreProgramButton({
  program,
  openModalSuccess,
  openModalError,
  refreshPrograms,
}: {
  program: IAppointmentsProgram;
  openModalSuccess: () => void;
  openModalError: () => void;
  refreshPrograms: () => void;
}) {
  const [showTooltipIndex, setShowTooltipIndex] = useState(false);
  const [postAppointmentsPrograms] = usePostAppointmentsProgramsMutation();

  return (
    <>
      <button
        type={"button"}
        className={`btn btn_type_restore`}
        onMouseEnter={() => setShowTooltipIndex(true)}
        onMouseLeave={() => setShowTooltipIndex(false)}
        onClick={() => {
          const { createUsersGuid, createUsersId, ...rest } = program;
          postAppointmentsPrograms({
            ...rest,
            statusId: 1,
            therapistsGuid: null,
          })
            .then((res) => {
              if ("data" in res) {
                openModalSuccess();
              }
            })
            .catch((err) => {
              openModalError();
              console.log(err);
            })
            .finally(() => {
              refreshPrograms();
            });
        }}
      >
        <Tooltip isShown={showTooltipIndex} position="left">{t('RESTORE_PLAN')}</Tooltip>
      </button>
    </>
  );
}

export default RestoreProgramButton;
